import React from "react";
import { Stack, Text } from "@bookingcom/bui-react";
export function FlightDetailsTitleMobileUI(props) {
    const { attributes, mixin, text } = props;
    return (React.createElement(Stack, { attributes: attributes, mixin: mixin },
        React.createElement(Text, { variant: "headline_2", tagName: "h1" }, text)));
}
